import { createFileRoute } from '@tanstack/react-router'
import { OutgrowerMonitoringQuestionnaireForm } from '@/components/forms/outgrower-monitoring-questionnaire-form'

export const Route = createFileRoute('/_offline-forms/outgrower-monitoring-questionnaire')({
  component: OutgrowerMonitoringQuestionnaireComponent,
})

function OutgrowerMonitoringQuestionnaireComponent() {
  return (
    <div className="flex items-center justify-center">
      <div className="h-full w-full max-w-xl px-4 flex flex-col gap-4">
        <OutgrowerMonitoringQuestionnaireForm />
      </div>
    </div>
  )
}
